module.exports = __webpack_public_path__ + "static/media/90.fd8d18fe.png";